var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDice6Sided(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "700pt",
    height: "700pt",
    viewBox: "0 0 700 700",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m552.05 172.7-205.86-131.71c-3.9844-2.6367-9.1992-2.457-12.992 0.44922l-186.14 140c-2.8984 2.2773-4.4883 5.8398-4.2539 9.5195l5.6016 168h-0.003906c0.12891 3.4531 1.8438 6.6602 4.6484 8.6797l205.91 148.06c1.9062 1.3828 4.1992 2.125 6.5508 2.1289 2.7578 0.082031 5.4492-0.85156 7.5586-2.6328l174.89-159.71c2.2266-2.0352 3.5391-4.8828 3.6406-7.8945l5.6016-165.09h-0.003906c0.13281-3.9453-1.8281-7.668-5.1523-9.8008zm-211.34-108.7 191.57 122.64-167.16 145.6-196.78-138.43zm-169.9 288.79-4.9297-146.89 194.04 136.13v146.78zm200.48 133.84v-145.04l162.9-141.79-4.9844 142.3zm-35.504-328.11c-2.1094-1.5391-4.5781-2.5039-7.168-2.8008-4.8398-0.76953-9.7227 1.0859-12.824 4.875-5.2656 5.8789-5.2656 13.215 0 22.062 4.8125 6.8164 10.453 13.004 16.801 18.426-1.2109-4.5312-1.2109-9.3008 0-13.832 1.3867-4.5391 3.7344-8.7188 6.8867-12.266 6.7852-8.0508 16.801-12.668 27.328-12.602 11.777 0.13672 23.152 4.3281 32.199 11.875 10.082 7.4961 17.609 17.918 21.559 29.848 3.9766 11.984 1.3438 23.969-8.0078 35.953v-0.003907c-4.6445 6.2773-11.105 10.969-18.508 13.445-7.4062 2.4727-15.391 2.6094-22.875 0.38672-15.711-4.2578-30.199-12.16-42.281-23.07-6.9258-5.6289-13.523-11.652-19.766-18.031-7.2578-7.3867-13.07-16.066-17.137-25.594-2.6289-6.5508-3.5703-13.652-2.7461-20.664 0.98828-7.1484 4.2266-13.797 9.2422-18.984 6.4609-7.6953 15.57-12.691 25.535-14 9.707-0.92578 19.422 1.6602 27.383 7.2812zm43.457 72.801h-0.003906c5.7148 0.54687 11.309-1.8594 14.84-6.3828 1.7148-2.0195 2.8633-4.457 3.3242-7.0664 0.46094-2.6055 0.22266-5.2891-0.69141-7.7734-2.2266-6.1055-6.25-11.395-11.535-15.176-5.043-4.6602-11.52-7.4648-18.367-7.9531-5.2422-0.24609-10.297 1.9688-13.664 5.9922-2.6836 3.1016-4.1016 7.0977-3.9766 11.199 0.77734 7.6602 4.8672 14.598 11.199 18.984 5.2109 4.7188 11.859 7.543 18.871 8.0078z"
  }), /*#__PURE__*/React.createElement("use", {
    x: 70,
    y: 644,
    xlinkHref: "#w"
  }), /*#__PURE__*/React.createElement("use", {
    x: 90.550781,
    y: 644,
    xlinkHref: "#d"
  }), /*#__PURE__*/React.createElement("use", {
    x: 104.359375,
    y: 644,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("use", {
    x: 123.347656,
    y: 644,
    xlinkHref: "#f"
  }), /*#__PURE__*/React.createElement("use", {
    x: 142.242188,
    y: 644,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("use", {
    x: 155.628906,
    y: 644,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("use", {
    x: 174.617188,
    y: 644,
    xlinkHref: "#k"
  }), /*#__PURE__*/React.createElement("use", {
    x: 204.410156,
    y: 644,
    xlinkHref: "#j"
  }), /*#__PURE__*/React.createElement("use", {
    x: 224.453125,
    y: 644,
    xlinkHref: "#i"
  }), /*#__PURE__*/React.createElement("use", {
    x: 252.453125,
    y: 644,
    xlinkHref: "#h"
  }), /*#__PURE__*/React.createElement("use", {
    x: 270.292969,
    y: 644,
    xlinkHref: "#c"
  }), /*#__PURE__*/React.createElement("use", {
    x: 289.53125,
    y: 644,
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("use", {
    x: 309.460938,
    y: 644,
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("use", {
    x: 329.398438,
    y: 644,
    xlinkHref: "#v"
  }), /*#__PURE__*/React.createElement("use", {
    x: 338.992188,
    y: 644,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("use", {
    x: 367.734375,
    y: 644,
    xlinkHref: "#u"
  }), /*#__PURE__*/React.createElement("use", {
    x: 386.832031,
    y: 644,
    xlinkHref: "#f"
  }), /*#__PURE__*/React.createElement("use", {
    x: 405.726562,
    y: 644,
    xlinkHref: "#t"
  }), /*#__PURE__*/React.createElement("use", {
    x: 425.769531,
    y: 644,
    xlinkHref: "#s"
  }), /*#__PURE__*/React.createElement("use", {
    x: 442.4375,
    y: 644,
    xlinkHref: "#g"
  }), /*#__PURE__*/React.createElement("use", {
    x: 459.03125,
    y: 644,
    xlinkHref: "#c"
  }), /*#__PURE__*/React.createElement("use", {
    x: 478.269531,
    y: 644,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("use", {
    x: 491.65625,
    y: 644,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("use", {
    x: 70,
    y: 672,
    xlinkHref: "#r"
  }), /*#__PURE__*/React.createElement("use", {
    x: 82.183594,
    y: 672,
    xlinkHref: "#d"
  }), /*#__PURE__*/React.createElement("use", {
    x: 95.992188,
    y: 672,
    xlinkHref: "#c"
  }), /*#__PURE__*/React.createElement("use", {
    x: 115.226562,
    y: 672,
    xlinkHref: "#q"
  }), /*#__PURE__*/React.createElement("use", {
    x: 154.152344,
    y: 672,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("use", {
    x: 167.535156,
    y: 672,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 187.46875,
    y: 672,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("use", {
    x: 216.207031,
    y: 672,
    xlinkHref: "#o"
  }), /*#__PURE__*/React.createElement("use", {
    x: 239.640625,
    y: 672,
    xlinkHref: "#c"
  }), /*#__PURE__*/React.createElement("use", {
    x: 258.878906,
    y: 672,
    xlinkHref: "#n"
  }), /*#__PURE__*/React.createElement("use", {
    x: 278.8125,
    y: 672,
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("use", {
    x: 308.492188,
    y: 672,
    xlinkHref: "#m"
  }), /*#__PURE__*/React.createElement("use", {
    x: 329.015625,
    y: 672,
    xlinkHref: "#d"
  }), /*#__PURE__*/React.createElement("use", {
    x: 342.820312,
    y: 672,
    xlinkHref: "#c"
  }), /*#__PURE__*/React.createElement("use", {
    x: 362.058594,
    y: 672,
    xlinkHref: "#l"
  }), /*#__PURE__*/React.createElement("use", {
    x: 371.65625,
    y: 672,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("use", {
    x: 390.648438,
    y: 672,
    xlinkHref: "#g"
  }), /*#__PURE__*/React.createElement("use", {
    x: 407.242188,
    y: 672,
    xlinkHref: "#a"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDice6Sided);
export default __webpack_public_path__ + "static/media/dice6sided.62a143d39fc0be0a5d4b7975628a0351.svg";
export { ForwardRef as ReactComponent };